import { render, staticRenderFns } from "./WashcloudPlatformProduct.vue?vue&type=template&id=59f059e7&scoped=true"
import script from "./WashcloudPlatformProduct.vue?vue&type=script&lang=js"
export * from "./WashcloudPlatformProduct.vue?vue&type=script&lang=js"
import style0 from "./WashcloudPlatformProduct.vue?vue&type=style&index=0&id=59f059e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f059e7",
  null
  
)

export default component.exports